export const MAKE_REQUEST = "MAKE_REQUEST";
export const FAIL_REQUEST = "FAIL_REQUEST";
export const GET_ALL_COURSES = "GET_ALL_COURSES";
export const GET_ALL_JOINED_COURSES = "GET_ALL_JOINED_COURSES";
export const GET_COURSE_DETAIL = "GET_COURSE_DETAIL";
export const GET_SECTION_DETAIL = "GET_SECTION_DETAIL";
export const ENROLLMENT_STATUS = "ENROLLMENT_STATUS";
export const ENROLLMENT_SUCCESS = "ENROLLMENT_SUCCESS";
